<template>
  <RygenButton
    class="remove-button"
    mode="tertiary"
    icon="pi pi-times"
    :aria-label="t('common.remove')"
    :disabled="disabled"
    @click="emit('click', $event)"
  />
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: () => false,
  },
});
const { disabled } = toRefs(props);
const emit = defineEmits<{
  (event: 'click', payload: MouseEvent): void;
}>();

const { t } = useI18n();
</script>
